import './Footer.scss';
import { LINKS } from '../../utils/constants';
import TrackingModal from '../../components/TrackingModal/TrackingModal';
import messages from './messages';
import { selectLocalSettings } from '../../ducks/settings';
import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useToggle } from 'react-use';

const Footer = () => {
  const languageLocal = useSelector(selectLocalSettings);
  const location = useLocation();
  const intl = useIntl();
  const [showTrackingModal, toggleTrackingModal] = useToggle(false);

  useEffect(() => {
    const element = document.getElementById('global-navigation');
    if (element) return;
    const script = document.createElement('script');
    script.setAttribute('id', 'global-navigation');
    script.setAttribute('type', 'text/javascript');
    script.src = LINKS.GlobalNavigationScript;
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return (
    <>
      <TrackingModal open={showTrackingModal} onClose={toggleTrackingModal} />
      <div onClick={toggleTrackingModal} className="footer-cookies-desktop">
        <span>{intl.formatMessage({ ...messages.setCookies })}</span>
      </div>
      {
        // eslint-disable-next-line
        // @ts-ignore
        <global-footer
          locale={languageLocal}
          class="global-footer--default"
          open-in-same-window="true"
          language-selector-url={`${
            LINKS.GlobalNavigationRedirectionURL
          }${location.pathname.substring(7)}`}
        />
      }
      <div onClick={toggleTrackingModal} className="footer-cookies-mobile">
        {intl.formatMessage({ ...messages.setCookies })}
      </div>
    </>
  );
};

export default Footer;
